const AIRPODS_CAMPAIGN_FLOWS: ReadonlySet<string> = new Set(['dental', 'dental-revamp'])

export const isAirpodsCampaignFlow = (flowName: string) => AIRPODS_CAMPAIGN_FLOWS.has(flowName)

export const isAirpodsCoupon = (code: unknown) =>
  typeof code === 'string' && code.toLowerCase().includes('airpods')
